import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isActive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template-activatable/src/index.tsx
import React from 'react';
import baseIcon, { navigationActivatableDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NavigationIconProfilePath = 'M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9939 5.3751 18.6249 0.00606449 12 0ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C21.9967 17.5215 17.5215 21.9967 12 22ZM16 11C17.1046 11 18 10.1046 18 9C18 7.89543 17.1046 7 16 7C14.8954 7 14 7.89543 14 9C14 10.1046 14.8954 11 16 11ZM12 18C9.3504 17.9967 7.20331 15.8496 7.2 13.2H9.2C9.2 14.7464 10.4536 16 12 16C13.5464 16 14.8 14.7464 14.8 13.2H16.8C16.7967 15.8496 14.6496 17.9967 12 18ZM6 9C6 10.1046 6.89543 11 8 11C9.10457 11 10 10.1046 10 9C10 7.89543 9.10457 7 8 7C6.89543 7 6 7.89543 6 9Z';
var NavigationIconProfileActivePath = 'M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C23.9939 5.3751 18.6249 0.00606449 12 0ZM6 9C6 7.89543 6.89543 7 8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9ZM12 18.969C9.24443 18.9646 7.01185 16.7316 7.008 13.976H16.992C16.9881 16.7316 14.7556 18.9646 12 18.969ZM16 11C14.8954 11 14 10.1046 14 9C14 7.89543 14.8954 7 16 7C17.1046 7 18 7.89543 18 9C18 10.1046 17.1046 11 16 11Z';
var NavigationIcon = baseIcon('NavigationIconProfile', {
  getPath: _ref => {
    var {
      isActive
    } = _ref;
    return isActive ? NavigationIconProfileActivePath : NavigationIconProfilePath;
  },
  styleSheetPropsGetter: (_ref2, designVersion) => {
    var {
      isActive,
      color,
      colorToken,
      colorTokenArgs
    } = _ref2;
    return {
      isActive,
      color,
      designVersion,
      colorToken,
      colorTokenArgs
    };
  },
  defaultStyleSheetGetter: navigationActivatableDefaultStyleSheetGetter,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  restOfPropsSanitizer: _ref3 => {
    var {
        isActive
      } = _ref3,
      restOfProps = _objectWithoutProperties(_ref3, _excluded);
    return restOfProps;
  },
  groupProps: _objectSpread(_objectSpread({}, defaultNavigationIconGroupProps), {}, {
    x: 3,
    y: 3
  }),
  shapeSize: defaultNavigationIconShapeSize
});
var NavigationIconProfile = props => {
  useDeprecationWarning({
    componentName: 'NavigationIconProfile',
    removalDate: 'v6.0.0'
  });
  return /*#__PURE__*/React.createElement(NavigationIcon, props);
};
NavigationIconProfile.displayName = 'NavigationIconProfile';
export default NavigationIconProfile;
//# sourceMappingURL=index.js.map